import { z } from "zod";
import { buttonHierarchies, fontWeights } from "../brand-kit";
import { MarketingForgeElementType } from "../forge/marketing-signup-forge-types";
import { ButtonAction, CustomFieldType, inputTypes } from "../signup-form";

const RichTextElementSchema_ = z.object({
  id: z.number(),
  type: z.literal(MarketingForgeElementType.RICH_TEXT),
  html: z.string(),
  fontFamily: z.string(),
  fontWeight: z.enum(fontWeights),
  fontSizePx: z.number(),
  textColor: z.string(),
  linkColor: z.string(),
});
export const RichTextElementSchema: z.ZodType<RichTextElement> =
  RichTextElementSchema_;
export type RichTextElement = z.infer<typeof RichTextElementSchema_>;

const ButtonElementSchema_ = z.object({
  type: z.literal(MarketingForgeElementType.BUTTON),
  hierarchy: z.enum(buttonHierarchies),
  text: z.string(),
  action: z.enum(ButtonAction),
});
export const ButtonElementSchema: z.ZodType<ButtonElement> =
  ButtonElementSchema_;
export type ButtonElement = z.infer<typeof ButtonElementSchema_>;

const InputElementSchema_ = z.object({
  type: z.literal(MarketingForgeElementType.INPUT),
  inputType: z.enum(inputTypes),
  placeholderText: z.string(),
  customField: z
    .object({ id: z.string(), fieldType: z.enum(CustomFieldType) })
    .optional(),
});
export const InputElementSchema: z.ZodType<InputElement> = InputElementSchema_;
export type InputElement = z.infer<typeof InputElementSchema_>;

const ImageElementSchema_ = z.object({
  type: z.literal(MarketingForgeElementType.IMAGE),
  url: z.string(),
});
export const ImageElementSchema: z.ZodType<ImageElement> = ImageElementSchema_;
export type ImageElement = z.infer<typeof ImageElementSchema_>;

const ElementUnion = z.union([
  RichTextElementSchema_,
  ButtonElementSchema_,
  InputElementSchema_,
  ImageElementSchema_,
]);

const ColumnElementSchema_ = z.object({
  type: z.literal(MarketingForgeElementType.COLUMN),
  elements: z.array(z.lazy(() => ElementUnion)),
  totalColumns: z.number(),
  columnWidths: z.array(z.number()).optional(),
});
export const ColumnElementSchema: z.ZodType<ColumnElement> =
  ColumnElementSchema_;
export type ColumnElement = z.infer<typeof ColumnElementSchema_>;
